// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Steps_bg2__lxuxg {
    background: linear-gradient(to bottom, #d6fffd, transparent);
    padding: 0 0 40px;
}
.Steps_easySteps__PKZBk {
    margin: 0 auto;
    display: block;
    height: 300px;
}
.Steps_stepImage__95-XR {
    height: 250px;
    margin: 0.75em 0;
}
.Steps_mainStep__LCsN7 {
    display: flex;
    align-items: center;
    justify-content: center;
}
.Steps_mainStepText__WPUCO {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.Steps_stepNumber__x391E {
    height: 166px;
}
.Steps_stepText__Rciyw {
    font-size: 30px;
    font-weight: 700;
    margin: 0;
}
.Steps_stepSubtext__G4u05 {
    font-size: 22px;
    font-weight: 600;
}

@media screen and (max-width: 1127px) {
    .Steps_easySteps__PKZBk {
        height: 150px;
    }
    .Steps_stepImage__95-XR {
        height: 150px;
    }
    .Steps_mainStep__LCsN7 {
        margin: 0 2%;
    }
    .Steps_stepSubtext__G4u05 {
        font-size: 18px;
    }
}
@media screen and (max-width: 992px) {
    .Steps_easySteps__PKZBk {
        height: 150px;
    }
}

@media screen and (max-width: 768px) {
    .Steps_stepNumber__x391E {
        height: 112px;
    }
    .Steps_stepText__Rciyw {
        font-size: 22px;
    }
    .Steps_stepSubtext__G4u05 {
        font-size: 12px;
    }
}

@media screen and (max-width: 563px) {
    .Steps_easySteps__PKZBk {
        height: 100px;
    }
    .Steps_stepImage__95-XR {
        height: 100px;
        margin: 0.5em auto;
    }
    .Steps_mainStep__LCsN7 {
        justify-content: space-around;
    }
    .Steps_mainStepText__WPUCO {
        margin-right: 2em;
    }
    .Steps_stepNumber__x391E {
        height: 80px;
        display: block;
    }
}

@media screen and (max-width: 389px) {
    .Steps_mainStep__LCsN7 {
        flex-direction: column;
    }
    .Steps_mainStepText__WPUCO {
        margin: 0 auto;
    }
}

@media screen and (max-width: 350px) {
    .Steps_stepNumber__x391E {
        height: 60px;
        display: block;
    }
    .Steps_stepText__Rciyw {
        font-size: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Landing/Steps.module.css"],"names":[],"mappings":"AAAA;IACI,4DAA4D;IAC5D,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,cAAc;IACd,aAAa;AACjB;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,kBAAkB;IACtB;IACA;QACI,6BAA6B;IACjC;IACA;QACI,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,cAAc;IAClB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".bg2 {\n    background: linear-gradient(to bottom, #d6fffd, transparent);\n    padding: 0 0 40px;\n}\n.easySteps {\n    margin: 0 auto;\n    display: block;\n    height: 300px;\n}\n.stepImage {\n    height: 250px;\n    margin: 0.75em 0;\n}\n.mainStep {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.mainStepText {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n.stepNumber {\n    height: 166px;\n}\n.stepText {\n    font-size: 30px;\n    font-weight: 700;\n    margin: 0;\n}\n.stepSubtext {\n    font-size: 22px;\n    font-weight: 600;\n}\n\n@media screen and (max-width: 1127px) {\n    .easySteps {\n        height: 150px;\n    }\n    .stepImage {\n        height: 150px;\n    }\n    .mainStep {\n        margin: 0 2%;\n    }\n    .stepSubtext {\n        font-size: 18px;\n    }\n}\n@media screen and (max-width: 992px) {\n    .easySteps {\n        height: 150px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .stepNumber {\n        height: 112px;\n    }\n    .stepText {\n        font-size: 22px;\n    }\n    .stepSubtext {\n        font-size: 12px;\n    }\n}\n\n@media screen and (max-width: 563px) {\n    .easySteps {\n        height: 100px;\n    }\n    .stepImage {\n        height: 100px;\n        margin: 0.5em auto;\n    }\n    .mainStep {\n        justify-content: space-around;\n    }\n    .mainStepText {\n        margin-right: 2em;\n    }\n    .stepNumber {\n        height: 80px;\n        display: block;\n    }\n}\n\n@media screen and (max-width: 389px) {\n    .mainStep {\n        flex-direction: column;\n    }\n    .mainStepText {\n        margin: 0 auto;\n    }\n}\n\n@media screen and (max-width: 350px) {\n    .stepNumber {\n        height: 60px;\n        display: block;\n    }\n    .stepText {\n        font-size: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg2": `Steps_bg2__lxuxg`,
	"easySteps": `Steps_easySteps__PKZBk`,
	"stepImage": `Steps_stepImage__95-XR`,
	"mainStep": `Steps_mainStep__LCsN7`,
	"mainStepText": `Steps_mainStepText__WPUCO`,
	"stepNumber": `Steps_stepNumber__x391E`,
	"stepText": `Steps_stepText__Rciyw`,
	"stepSubtext": `Steps_stepSubtext__G4u05`
};
export default ___CSS_LOADER_EXPORT___;
